// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export const MAX_RECORDS_TO_SHOW = 20;
export const MIN_CHARS_SEARCH = 2;
